module.exports = __webpack_public_path__ + "static/media/TG.076d6a0d.png";